module.exports = __webpack_public_path__ + "static/media/logo.7d5de791.svg";